import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialogModel } from '../../common/interfaces/IDialogModel.interface';
import { TranslationService } from '../../common/services/translation.service';

/**
 * data :{title?: 'some title', content: 'some content'};
 */
@Component({
    selector: 'cpq-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['../confirm-dialog/confirm-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IDialogModel,
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<AlertDialogComponent>) { }

  close() {
    this.dialogRef.close(false);
  }

  ngOnInit() { }
}
